export const mediaQueries = {
    small: '(max-width: 919px)',
    medium: '(min-width: 920px)',
};
